import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { X, ArrowUp } from "lucide-react";
import { useUserContexts } from "@/hooks/useUserContexts";

const HINT_KEY = "context_switch_hint_dismissed";

export function ContextSwitchHint() {
  const { contexts } = useUserContexts();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Only show for users with multiple contexts who haven't dismissed the hint
    const hasDismissed = localStorage.getItem(HINT_KEY);
    if (contexts.length > 1 && !hasDismissed) {
      // Show hint after a short delay
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [contexts]);

  const handleDismiss = () => {
    localStorage.setItem(HINT_KEY, "true");
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed top-20 right-6 z-[150] animate-fade-in">
      <div className="bg-primary text-primary-foreground p-4 rounded-lg shadow-2xl max-w-sm relative">
        <Button
          variant="ghost"
          size="sm"
          onClick={handleDismiss}
          className="absolute top-2 right-2 h-6 w-6 p-0 hover:bg-primary-foreground/20"
        >
          <X className="h-4 w-4" />
        </Button>
        <div className="pr-8">
          <p className="font-medium mb-2">💡 Quick Tip</p>
          <p className="text-sm opacity-90">
            Use the Context Switcher above to switch between your Professional and Site views
          </p>
        </div>
        <div className="absolute -top-3 right-12 text-primary">
          <ArrowUp className="h-6 w-6" />
        </div>
      </div>
    </div>
  );
}
